import React from 'react';
import EventIcon from '@material-ui/icons/Event';
import i18n from 'i18n-js';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import ViewListIcon from '@material-ui/icons/ViewList';

import { images } from 'assets';
import NewOrdersCounter from './NewOrdersCounter';
import { NavbarList } from './NavbarList';
import NavbarListItem from './NavbarListItem';
import { Positions } from 'constants/enums';
import { RESERVATION_POSITIONS } from 'helpers/reservationHelper';
import ReservationRequestsCounter from './ReservationRequestsCounter';

interface RestaurantEmployeeNavbarProps {
    isOpen: boolean;
    position: Positions;
}

export default function RestaurantEmployeeNavbar(props: RestaurantEmployeeNavbarProps) {
    return (
        <NavbarList isOpen={props.isOpen}>
            <NavbarListItem
                isOpen={props.isOpen}
                path="/orders"
                icon={<BorderColorIcon />}
                title={i18n.t('navigationTabs.orders')}
            />
            <NewOrdersCounter isOpen={props.isOpen} />
            {RESERVATION_POSITIONS.includes(props.position) && (
                <>
                    <NavbarListItem
                        isOpen={props.isOpen}
                        path="/reservations"
                        icon={<EventIcon />}
                        title={i18n.t('restaurant.reservations')}
                    />
                    <ReservationRequestsCounter isOpen={props.isOpen} />
                </>
            )}
            <NavbarListItem
                isOpen={props.isOpen}
                path="/menu"
                icon={<ViewListIcon />}
                title={i18n.t('navigationTabs.menu')}
            />
            {props.position === Positions.WAITER && (
                <NavbarListItem
                    isOpen={props.isOpen}
                    path="/transactions"
                    icon={images.icons.receiptLong}
                    title={i18n.t('navigationTabs.transactions')}
                />
            )}
        </NavbarList>
    );
}
